module.exports = __webpack_public_path__ + "img/product-update-log-active.0c895ea8.svg";